import React from 'react';
import { FormattedMessage } from 'react-intl';

const NothingToExportNotificationContent = () => {
    return (
        <FormattedMessage
          id="ids_nothingToExportMessage"
          description="nothing to export message"
          defaultMessage="Il n'y a aucune donnée à exporter"
        />
    );
}

export default NothingToExportNotificationContent;